<template>
  <div class="canvas-creatures">
    <canvas class="creatures" ref="creaturesCanvas"></canvas>
  </div>
</template>
<script>
import animMixin from "@/assets/js/animMixin.js";
export default {
  name: "canvasCreatures",
  mixins: [animMixin],
  props: {
    animProg: Boolean
  },

  data() {
    return {
      creatures_cx: null,
      cx4: null,
      numCreatures: 12,
      creature: {
        minspeed: -0.5,
        maxspeed: 0.5,
        sizes: [150, 60, 100, 200, 500, 200, 80, 60, 80],
        sparkles: 5
      },
      sparkle: {
        wmin: 1,
        wmax: 3
      },
      creatures: [],
      w: null,
      h: null,
      creaturesAnim: false,
      anCreatures: 0
    };
  },
  mounted() {
    this.initCanvas();
    this.spawnCreatures();


    // window.addEventListener("resize", this.canvasResize);
  },
  beforeDestroy() {
    this.creaturesAnim = false;
    this.anCreatures = 0;
    // window.removeEventListener("resize", this.canvasResize);
  },
  methods: {
    canvasResize() {
      this.creatures = [];
      this.initCanvas();
      this.spawnCreatures();
    },

    initCanvas() {
      this.creatures_cx = this.$refs.creaturesCanvas;
      this.creatures_cx.width = this.$refs.creaturesCanvas.parentElement.clientWidth;
      this.creatures_cx.height = this.$refs.creaturesCanvas.parentElement.clientHeight;
      this.cx4 = this.creatures_cx.getContext("2d", { alpha: false });
      this.cx4.fillRect(0, 0, this.w, this.h);
      this.cx4.fillStyle = "#000";
      this.cx4.globalCompositeOperation = 'hard-light';
      this.w = this.creatures_cx.width;
      this.h = this.creatures_cx.height;
    },

    spawnCreatures() {
      for (let i = 0; i < this.numCreatures; i++) {
        let crtr = this.createCreature(i);

        this.creatures.push(crtr);
      }
      // console.log(this.creatures);
    },
    createCreature(i) {
      let creature = {};
      creature.id = i;
      creature.x = this.randomNum(this.w / 3, (this.w / 3) * 2, true);
      creature.y = this.randomNum(this.h / 3, (this.h / 3) * 2, true);
      creature.speedx = this.randomNum(
        this.creature.minspeed,
        this.creature.maxspeed
      );
      creature.speedy = this.randomNum(
        this.creature.minspeed,
        this.creature.maxspeed
      );
      creature.r = this.randomSample(this.creature.sizes);
      creature.sparklesPot = [];
      this.fillSparklesPot(creature);

      return creature;
    },
    fillSparklesPot(cr) {
      // console.log(cr);
      for (let i = 0; i < this.creature.sparkles; i++) {
        let sprkl = this.createSparkle(cr);

        cr.sparklesPot.push(sprkl);
      }
    },
    updateSparklesPot(i) {
      this.creatures[i].sparklesPot = [];

      for (let y = 0; y < this.creature.sparkles; y++) {
        let s = this.newSparkle(i);
        this.creatures[i].sparklesPot.push(s);
      }
    },
    newSparkle(i) {
      let sparkle = {};
      sparkle.const = Math.random() * Math.PI * 2;
      sparkle.sw = this.randomNum(this.sparkle.wmin, this.sparkle.wmax);
      sparkle.sx =
        this.creatures[i].x + this.creatures[i].r * Math.cos(sparkle.const);
      sparkle.sy =
        this.creatures[i].y + this.creatures[i].r * Math.sin(sparkle.const);
      sparkle.col = "hsl(" + this.randomNum(100, 200, true) + ",100%, 50%)";
      return sparkle;
    },
    sparkleAnim(i, y) {
      let lotto = Math.random();
      if (lotto < 0.05) {
        this.creatures[i].sparklesPot[y].sw = this.randomNum(
          this.sparkle.wmin,
          this.sparkle.wmax
        );
        this.creatures[i].sparklesPot[y].col =
          "hsl(" +
          this.randomNum(200, 300, true) +
          ", 100%, " +
          this.randomNum(50, 70, true) +
          "%)";
      }
      if (lotto > 0.999) {
        let s = this.newSparkle(i);
        this.creatures[i].sparklesPot.push(s);
        this.creatures[i].sparklesPot.shift();
      }
    },
    createSparkle(cr) {
      let sparkle = {};
      sparkle.const = Math.random() * Math.PI * 2;
      sparkle.sw = this.randomNum(this.sparkle.wmin, this.sparkle.wmax);
      sparkle.sx = cr.x + cr.r * Math.cos(sparkle.const);
      sparkle.sy = cr.y + cr.r * Math.sin(sparkle.const);
      sparkle.col = "hsl(" + this.randomNum(100, 200, true) + ",100%, 50%)";
      return sparkle;
    },

    renderCreatures(i) {
      //this.cx4.fillStyle = "black";

      // this.cx4.beginPath();

      // this.cx4.arc(
      // 	this.creatures[i].x,
      // 	this.creatures[i].y,
      // 	this.creatures[i].r,
      // 	0,
      // 	2 * Math.PI
      // );
      // this.cx4.stroke();
      this.sparklesRender(i);
    },
    moveCreatures(i) {
      this.creatures[i].x += this.creatures[i].speedx;
      this.creatures[i].y += this.creatures[i].speedy;
      this.sparklesMove(i);
    },
    // showCreatures() {
    // 	this.cx4.beginPath();
    // 	this.cx4.arc(100, 100, 100, 0, 2 * Math.PI);
    // 	this.cx4.stroke();
    // },
    edgesCreatures(i) {
      if (this.creatures[i].x > this.w + this.creatures[i].r * 2) {
        //this.dx = -this.dx;
        this.creatures[i].x = -this.creatures[i].r * 2;
        this.sparklesUpdate(i);
      }
      if (this.creatures[i].y < -this.creatures[i].r * 2) {
        //this.dx = -this.dx;
        this.creatures[i].y = this.h + this.creatures[i].r * 2;
        this.sparklesUpdate(i);
      }
      if (this.creatures[i].x < -this.creatures[i].r * 2) {
        //this.dx = -this.dx;
        this.creatures[i].x = this.w - this.creatures[i].r * 2;
        this.sparklesUpdate(i);
      }
      if (this.creatures[i].y > this.h + this.creatures[i].r * 2) {
        //this.dx = -this.dx;
        this.creatures[i].y = -this.creatures[i].r * 2;
        this.sparklesUpdate(i);
      }
    },
    sparklesRender(i) {
      for (var y = 0; y < this.creature.sparkles; y++) {
        // this.sparkles[i].sparkleanim();
        this.cx4.fillStyle = this.creatures[i].sparklesPot[y].col;
        this.cx4.fillRect(
          this.creatures[i].sparklesPot[y].sx,
          this.creatures[i].sparklesPot[y].sy,
          this.creatures[i].sparklesPot[y].sw,
          this.creatures[i].sparklesPot[y].sw
        );
      }
    },
    sparklesMove(i) {
      for (var y = 0; y < this.creature.sparkles; y++) {
        this.creatures[i].sparklesPot[y].sx += this.creatures[i].speedx;
        this.creatures[i].sparklesPot[y].sy += this.creatures[i].speedy;
        this.sparkleAnim(i, y);
      }
    },
    sparklesUpdate(i) {
      this.updateSparklesPot(i);
    },

    performAnimCreatures() {
      this.cx4.fillStyle = "#000";
      this.cx4.fillRect(0, 0, this.w, this.h);
      if (this.creaturesGo === false) return;
      // console.log("creatures going!");
      for (var i = 0; i < this.creatures.length; i++) {
        this.edgesCreatures(i);
        this.moveCreatures(i);
        this.renderCreatures(i);
      }

      requestAnimationFrame(this.performAnimCreatures);
    }
  },
  computed: {
    creaturesGo() {
      return this.anCreatures !== 0 ? true : false;
    }
  },
  watch: {
    creaturesGo(newval) {
      if (newval === true) {
        requestAnimationFrame(this.performAnimCreatures);
      } else {
        cancelAnimationFrame(this.performAnimCreatures);
      }
    },
    animProg(newval) {
        if (newval){
            this.anCreatures = 1;
        }
        else {
            this.anCreatures = 0;
        }

    }
  }
};
</script>
<style lang="scss">
.canvas-creatures {
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 1;
  transition: opacity 1s ease-in;


  .creatures {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
